import "./BonusDocumentTable.css";

export interface BonusDocumentRow {
  documento?: string;
  nome?: string;
  conforme?: boolean;
  percentual?: number | null;
  valor?: string | number;
}

export interface BonusDocumentTableProps {
  data: BonusDocumentRow[];
  title: [string, string, string, string];
}

const BonusDocumentTable = ({ data, title }: BonusDocumentTableProps) => {
  const valorTotal = data.reduce((sum, item) => {
    let valorNumerico = 0;

    if (typeof item.valor === "string") {
      valorNumerico =
        parseFloat(
          item.valor
            .replace("R$", "")
            .replace(/\./g, "")
            .replace(",", ".")
            .trim(),
        ) || 0;
    } else if (typeof item.valor === "number") {
      valorNumerico = item.valor;
    }

    return sum + valorNumerico;
  }, 0);

  return (
    <div className="table-responsive mt-4">
      <table className="bonus-doc-table">
        <thead>
          <tr>
            <th>{title[0]}</th>
            <th>{title[1]}</th>
            <th>{title[2]}</th>
            <th>{title[3]}</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, idx) => (
            <tr key={idx}>
              <td>{item.documento || item.nome || "-"}</td>
              <td>{item.conforme ? "Sim" : "Não"}</td>
              <td>{item.percentual != null ? `${item.percentual}%` : "-"}</td>
              <td>
                {typeof item.valor === "number"
                  ? item.valor.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                      minimumFractionDigits: 2,
                    })
                  : item.valor || "R$ 0,00"}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="total-row">
            <td colSpan={3} className="label">
              VALOR TOTAL:
            </td>
            <td className="valor-total">
              {valorTotal.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
              })}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default BonusDocumentTable;
